/* ===================================================================
   product-page.js  —  Tescoma
   Scripts de la ficha de producto, externalizados desde main-product.liquid
   para mejorar caché y rendimiento (se descarga una vez, no en cada ficha).

   Contiene:
   - Entrega estimada (días hábiles)
   - Galería escritorio (zoom, miniaturas, flechas, vídeo overlay)
   - Sticky CTA móvil
   =================================================================== */
(function () {
  'use strict';

  /* ---------- 1. ENTREGA ESTIMADA ---------- */
  function initDeliveryEstimate() {
    (function() {
                  function getBusinessDays(days) {
                    var date = new Date();
                    if (date.getHours() >= 14) date.setDate(date.getDate() + 1);
                    var added = 0;
                    while (added < days) {
                      date.setDate(date.getDate() + 1);
                      var d = date.getDay();
                      if (d !== 0 && d !== 6) added++;
                    }
                    return date;
                  }
                  function formatDate(date) {
                    var days = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
                    var months = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
                    return days[date.getDay()] + ' ' + date.getDate() + ' de ' + months[date.getMonth()];
                  }
                  var el = document.getElementById('delivery-text');
                  if (!el) return;
                  var min = getBusinessDays(2);
                  var max = getBusinessDays(3);
                  var minStr = formatDate(min);
                  var maxStr = formatDate(max);
                  el.textContent = minStr === maxStr ? minStr : minStr + ' — ' + maxStr;
                })();
  }

  /* ---------- 2. GALERÍA ESCRITORIO + VÍDEO ---------- */
  function initGallery() {
    // Zoom suave en imagen principal
    // -----------------------------------------------------------------
    // Optimizado para no congelar el compositor de Chrome:
    //  - getBoundingClientRect() se lee UNA vez al entrar, no en cada move
    //  - las actualizaciones de transform se limitan a 1 por frame (rAF)
    //  - will-change se activa solo mientras el ratón está encima y se
    //    libera al salir, en vez de mantener la capa GPU pinchada siempre
    // -----------------------------------------------------------------
      (function() {
        var wrap = document.getElementById('dg-zoom-wrap');
        var img  = document.getElementById('dg-main-img');
        if (!wrap || !img || window.innerWidth <= 768) return;
        var scale = 1.6;
        var raf = 0, mx = 0, my = 0;

        function apply() {
          raf = 0;
          // Se lee el rect UNA vez por frame (no en cada mousemove): sigue estando
          // throttleado, pero siempre actualizado, así el zoom apunta justo donde
          // está el cursor aunque la página se haya desplazado tras entrar el ratón.
          // Leemos el rect del wrap (que no está transformado), no de la imagen,
          // así el scale no invalida el layout ni provoca lecturas caras.
          var r = wrap.getBoundingClientRect();
          var px = (mx - r.left) / r.width;
          var py = (my - r.top)  / r.height;
          var ox = Math.max(0, Math.min(1, px)) * 100;
          var oy = Math.max(0, Math.min(1, py)) * 100;
          img.style.transformOrigin = ox + '% ' + oy + '%';
          img.style.transform = 'scale(' + scale + ')';
        }

        wrap.addEventListener('mouseenter', function() {
          img.style.willChange = 'transform';
        });
        wrap.addEventListener('mousemove', function(e) {
          mx = e.clientX; my = e.clientY;
          if (!raf) raf = requestAnimationFrame(apply);
        });
        wrap.addEventListener('mouseleave', function() {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          img.style.transform = 'scale(1)';
          img.style.transformOrigin = 'center center';
          img.style.willChange = 'auto';         // libera la capa GPU
        });
      })();

      // Galería escritorio — función global para onclick inline
      var _dgIndex = 0;
      var _dgThumbs = null;

      window.dgGoTo = function(index, src) {
        if (window.innerWidth <= 768) return;

        var mainImg = document.getElementById('dg-main-img');
        if (!mainImg) return;

        // Ocultar el reproductor de vídeo si estaba activo
        var videoPlayer = document.getElementById('dg-video-player');
        if (videoPlayer) {
          videoPlayer.classList.remove('active');
          videoPlayer.innerHTML = '';
        }

        _dgIndex = index;

        // Cambiar imagen principal
        // Hay que limpiar srcset porque Shopify image_tag lo genera y el browser lo prioriza sobre src
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.style.opacity = '0.4';
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
        mainImg.src = src;
        // Si la imagen ya está en caché, 'onload' puede no dispararse: forzamos
        // opacidad plena para que la foto no se quede a medias.
        if (mainImg.complete) mainImg.style.opacity = '1';

        // Actualizar estado activo en miniaturas
        // Solo las miniaturas de FOTO (excluimos la del vídeo), porque 'index' es
        // el índice de imagen y así coincide con su posición aunque haya vídeo delante.
        if (!_dgThumbs) _dgThumbs = document.querySelectorAll('.dg-thumb:not(.dg-thumb--video)');
        _dgThumbs.forEach(function(t, i) {
          t.classList.toggle('active', i === index);
        });
      };

      // Reproducir vídeo de YouTube en overlay a pantalla completa (desktop y móvil)
      window.dgPlayVideo = function(videoId) {
        openVideoOverlay(videoId);
      };
      window.dgPlayVideoMobile = function(videoId) {
        openVideoOverlay(videoId);
      };

      function openVideoOverlay(videoId) {
        // Evitar duplicados
        var existing = document.getElementById('tescoma-video-overlay');
        if (existing) existing.remove();

        var overlay = document.createElement('div');
        overlay.id = 'tescoma-video-overlay';
        overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.92);'
          + 'display:flex;align-items:center;justify-content:center;padding:20px;'
          + 'animation:tescomaVidFade 0.2s ease;';
        overlay.innerHTML = '<div style="position:relative;width:100%;max-width:960px;aspect-ratio:16/9;">'
          + '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" '
          + 'style="width:100%;height:100%;border:0;border-radius:12px;box-shadow:0 10px 50px rgba(0,0,0,0.5);" '
          + 'title="Vídeo del producto" '
          + 'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" '
          + 'allowfullscreen></iframe>'
          + '<button aria-label="Cerrar vídeo" style="position:absolute;top:-48px;right:0;background:none;'
          + 'border:none;color:#fff;font-size:36px;cursor:pointer;line-height:1;padding:0;">&times;</button>'
          + '</div>';

        overlay.addEventListener('click', function(ev) {
          if (ev.target === overlay || ev.target.tagName === 'BUTTON') overlay.remove();
        });
        document.addEventListener('keydown', function escClose(e) {
          if (e.key === 'Escape') {
            var ov = document.getElementById('tescoma-video-overlay');
            if (ov) ov.remove();
            document.removeEventListener('keydown', escClose);
          }
        });

        document.body.appendChild(overlay);
      }

      // Flechas prev/next — las conectamos cuando el DOM está listo
      document.addEventListener('DOMContentLoaded', function() {
        if (window.innerWidth <= 768) return;

        _dgThumbs = document.querySelectorAll('.dg-thumb:not(.dg-thumb--video)');
        var prevBtn = document.getElementById('dg-prev');
        var nextBtn = document.getElementById('dg-next');
        var total   = _dgThumbs.length;

        function navTo(dir) {
          var next = (_dgIndex + dir + total) % total;
          var thumb = _dgThumbs[next];
          if (!thumb) return;
          // Obtener src del onclick: dgGoTo(N, 'URL')
          var match = (thumb.getAttribute('onclick') || '').match(/'([^']+)'/);
          if (match) dgGoTo(next, match[1]);
          thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function() { navTo(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function() { navTo(1); });
      });
  }

  /* ---------- 3. STICKY CTA MÓVIL ---------- */
  function initStickyCta() {
    document.addEventListener('DOMContentLoaded', function() {
        if (window.innerWidth > 768) return;

        var stickyAtc = document.getElementById('sticky-atc');
        if (!stickyAtc) return;

        // Conectar el botón sticky al botón real de añadir al carrito
        var stickyBtn = document.getElementById('sticky-atc-btn');
        if (stickyBtn) {
          stickyBtn.addEventListener('click', function() {
            var realBtn = document.querySelector('button[name="add"]:not(:disabled)')
                       || document.querySelector('.product-form__submit:not(:disabled)');
            if (realBtn) realBtn.click();
          });
        }

        // Mostrar/ocultar según visibilidad del botón principal
        var buyBtn = document.querySelector('.buy-buttons');
        if (!buyBtn) {
          stickyAtc.classList.add('sticky-atc--visible');
          return;
        }
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            stickyAtc.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
          });
        }, { threshold: 0 });
        observer.observe(buyBtn);
      });
  }

  /* ---------- ARRANQUE ---------- */
  function boot() {
    initDeliveryEstimate();
    initGallery();
    initStickyCta();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();